const initialState = {
  listClient: [],
};

const clientReducerKaltimtara = (state = initialState, action) => {
  let { type, data } = action;
  switch (type) {
    case "SET_ALLCLIENT":
      return {
        ...state,
        listClient: data,
      };
    default:
      return state;
  }
};
export default clientReducerKaltimtara;
